import { Account, TradingAccountDetails, AccountType } from '@/common/types'
import { NAVIGATION_COPY } from '@/locales/en'
import type { ActionableDetailItem } from '../types'

const EMPTY_VALUE = '-'

export const buildAccountDetailItems = (
    account: Account | null,
    tradingAccount?: TradingAccountDetails | undefined,
    tfnProvided?: boolean,
    onAddTfn?: () => void,
): ActionableDetailItem[] => {
    const copy = NAVIGATION_COPY.account.accountFields

    if (!account) {
        return [
            { key: 'name', label: copy.accountName, value: EMPTY_VALUE },
            { key: 'type', label: copy.accountType, value: EMPTY_VALUE },
            { key: 'number', label: copy.accountNumber, value: EMPTY_VALUE },
        ]
    }

    const items: ActionableDetailItem[] = [
        {
            key: 'name',
            label: copy.accountName,
            value: account.accountName || EMPTY_VALUE,
        },
        {
            key: 'type',
            label: copy.accountType,
            value: NAVIGATION_COPY.accountTypes[account.accountType] || EMPTY_VALUE,
        },
        {
            key: 'number',
            label: copy.accountNumber,
            value: account.accountId || EMPTY_VALUE,
        },
    ]

    if (account.accountType !== AccountType.ADVISER) {
        items.push(
            {
                key: 'tradingAccountNumber',
                label: copy.tradingAccountNumber,
                value: tradingAccount?.accountNumber || EMPTY_VALUE,
            },
            {
                key: 'tradingAccountHIN',
                label: copy.hin,
                value: tradingAccount?.hin || EMPTY_VALUE,
            },
        )
    }

    if (account.accountType === AccountType.INDIVIDUAL) {
        items.push({
            key: 'tfn',
            label: copy.tfn,
            value: tfnProvided ? copy.tfnProvidedValue : EMPTY_VALUE,
            ...(!tfnProvided && { onAdd: onAddTfn }),
        })
    }

    return items
}
